//Modules
import { useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

//Styles
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

//Utils
import useFetch from "../utils/useFetch";

//Variables
const { REACT_APP_IPBNEWS_GALERIA } = process.env

function PhotoGallery({ id_gallery }) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const carouselRef = useRef(null);
  let photos = [];

  const scrollBy = (offset) => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: offset, behavior: "smooth" });
    }
  };

  const result = useFetch(`${REACT_APP_IPBNEWS_GALERIA}${id_gallery}`);
  if (!result.loading && result.data && result.data.stat === "ok") {
    photos = result.data.result.images;
    photos.forEach(photo => {
      photo.src = photo.element_url
      photo.imageFit = "contain"
      photo.alt = photo.name
    })
  }

    if (result.isError) {
        console.log(result?.data?.stat)
        return <div></div>
    }else if (photos.length === 0 && !result.loading) {
        console.log("Galeria não encontrada ou sem fotos!!!")
        return <div></div>
    }

  return (
    <div className="photoGallery">
        
      {/* Thumbnail carousel */}
        <div className="thumbnailsContainer">
            {/* Left arrow */}
            <button onClick={() => scrollBy(-200)}>
                <span className="material-symbols-outlined">
                    arrow_back
                </span>
            </button>

            <div ref={carouselRef} className="thumbnails">
            {!result.loading && result.data && result.data.stat === "ok" && photos.map((photo, i) => (
                <img key={photo.id} src={photo.derivatives.thumb.url} alt={photo.name}
                onClick={() => {
                    setIndex(i);
                    setOpen(true);
                }}
                onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                }
                />
            ))}
            </div>

            {/* Right arrow */}
            <button onClick={() => scrollBy(200)}>
            <span className="material-symbols-outlined">
                    arrow_forward
                </span>
            </button>
        </div>

        {/* Lightbox with arrows + thumbnail strip */}
        <Lightbox
            open={open}
            close={() => setOpen(false)}
            index={index}
            slides={photos}
            plugins={[Thumbnails]}
        />
    </div>
  );

}

export default PhotoGallery
